import {Vue} from 'ui.vue';
import './app-vc-smarta.css';

Vue.component('app-vc-smarta', {
	props: {
		test: {},
		loaderlogo: {}
	},
	data()
	{
		return {
			uid: 'app-vc-smarta',
            config: {},
			refs: {
                treetags: false,
				tags: false
            },
			articles: [],
			form: {
				tags: []
			},
			timeout: false,
			debug: false,
			
			// пропускаемы теги
			skipTag: [],
		}
	},
	created () {
		// генерим uid
		this.uid = 'app-vc-smarta_'+Math.random().toString(36).substring(8);
		
        let self = this;
        self.config = APP.Util.cloneObject(APP.config);
		
		let url = self.config.interface+'/smarta/treetags.php';
		
		if (this.test) url = url + '?test=' + this.test;
		
		BX.ajax({   
                url: url,
                method: 'GET',
                dataType: 'json',
                timeout: 30,
                async: true,
                processData: true,
                scriptsRunFirst: true,
                emulateOnload: true,
                start: true,
                cache: false,
                onsuccess: function(data){
					if (data.treetags) {
                        let tags = {};
						for (let ist in data.treetags) {
                            for (let it in data.treetags[ist].TAGS) {
								let tag = data.treetags[ist].TAGS[it];
                                tags[tag.ID] = tag;
                            }
                        }
						
						Vue.set(self.refs, 'treetags', data.treetags);
						Vue.set(self.refs, 'tags', tags);
                    }
                    
                },
                onfailure: function(){
                    
                }
            });
	},
	computed: {
		treetags () {
			let treetags = APP.Util.cloneObject(this.refs.treetags);
			
			for (let iSect in treetags) {
				treetags[iSect]._SHOW = true;
				
                if (treetags[iSect].UF_TAGSHOW && treetags[iSect].UF_TAGSHOW.length) { // есть набор тегов при выборе которхых надо опказывать секцию.
					treetags[iSect]._SHOW = false;
					for (let iTagShow in treetags[iSect].UF_TAGSHOW) { // перебираем теги при выборе которых нужно показывать этот раздел
                        if (this.form.tags.includes(treetags[iSect].UF_TAGSHOW[iTagShow]+'')) { // набор выборанных тегов включает хотя бы один из перечисленных
							treetags[iSect]._SHOW = true;
							break;
						} else {
							console.log('this.form.tags U', treetags[iSect].UF_TAGSHOW[iTagShow]+'');
						}
                    }
                }
            }
			
			return treetags;
			
		}
	},
	methods: {
		
		reloadArticles () {
			let self = this;
			let myTimeout = self.timeout;
			BX.ajax({   
					url: self.config.interface+'/smarta/articles.php',
					method: 'POST',
					data: {'TAGS':self.form.tags, 'TEST':self.test},
					dataType: 'json',
					timeout: 30,
					async: true,
					processData: true,
					scriptsRunFirst: true,
					emulateOnload: true,
					start: true,
					cache: false,
					onsuccess: function(data){
						
						if (self.config.debug)  {
							Vue.set(self, 'debug', {axis: data.articles.axis});
							//console.log(data.articles.ref);
							//console.log(data.articles.abya);
						}
						
						if (data.articles?.items) Vue.set(self, 'articles', data.articles.items);
						
						if (myTimeout == self.timeout) {
                            self.timeout = false;
                        }
					},
					onfailure: function() {
						
					}
				});
		},
	},
	watch: {
		'form.tags' (val,oval) {
			this.articles = [];
			if (val.length > oval.length) {
                // добавился тег
				let addingTagId = val.filter(x => !oval.includes(x))[0];
				
				// отключение антитегов
				let antitags = this.refs.tags[addingTagId].PROPERTY_ANTITAG_VALUE;
				if (antitags.length) {
					
                    let deletedTagNames = []; // id удаленных тегов
					for (let i in antitags) {
                        let tagId = antitags[i]; // удаляемый элемент
						let idt = val.indexOf(tagId)
						while (idt > -1) {
							deletedTagNames.push(this.refs.tags[tagId].NAME);
							val.splice(idt,1);
							idt = val.indexOf(tagId)
						}
                    }
					
					if (deletedTagNames.length) {
						const popup = new BX.PopupWindow("vc_smarta_modal", null, {
								content: `
									<div class="box">
										<div class="left"><img src="/local/sources/src/img/logo.jpg" alt=""></div>
										<div class="right">
											<h3>Несовместимый выбор</h3>
											<div class="text">
												<p>Вы выбрали вариант <strong>`+this.refs.tags[addingTagId].NAME+`</strong>.</p>
												<p>Он не совместим со следующими вариантами: <strong>`+deletedTagNames.join('</strong>,<strong>')+`</strong>.</p>
												<p>Поэтому мы их отключили.</p>
											</div>
										</div>
									</div>
									`,
								autoHide: true,
								closeIcon: {right: "30px", top: "10px"},
								zIndex: 0,
								offsetLeft: 0,
								offsetTop: 0,
								draggable: {restrict: false},
								overlay: {backgroundColor: 'black', opacity: 0 },
								events: {
										onPopupClose: function () {
			//                              BX.X.Multipoints.vues.selector.$destroy();
			//								this.destroy();
										},
										onPopupShow: function () {
											
										}
									}
							});
						popup.show();
					}
                }
				
            }
			
			
			// перестраиваем список скрываемых тегов
			let skipTag = [];
			for (let i in val) {
                let hidetags = this.refs.tags[val[i]].PROPERTY_HIDETAG_VALUE;
				if (hidetags.length) {
                   skipTag = skipTag.concat(hidetags);
                }
            }
			this.skipTag = skipTag;
			
			//
			if (val.length > 1) {
				if (this.timeout) clearTimeout(this.timeout);
				this.timeout = setTimeout(this.reloadArticles,2000);
            }
			
		}
	},
	template: `
		<div class="vc_smarta">
		
            <h3>Расскажите немного о себе и получите актуальную для Вас информацию</h3>
			
            <div class="tegs" v-if="refs.treetags">
			
                <div class="item" v-for="sectags in treetags" v-bind:key="'sectags'+sectags.ID" v-if="sectags._SHOW">
                    <div class="icon"><img src="/local/sources/dist/img/icon.png" alt=""></div>
                    <div class="zag">{{sectags.NAME}}</div>
                    <div class="box" v-if="sectags.TAGS.length">
						<span class="tag"
								v-for="tag in sectags.TAGS"
								v-bind:key="'tag'+tag.ID"
								v-if="!skipTag.includes(tag.ID)"
							>
							<input type="checkbox"
									v-bind:id="uid+'_tag_'+tag.ID"
									v-model="form.tags"
									v-bind:value="tag.ID"
								/><label v-bind:for="uid+'_tag_'+tag.ID">{{tag.NAME}}</label>
						</span>
                    </div>
                </div>
				
            </div>
			
			<div v-if="debug?.axis?.length">
				<h3>Оси</h3>
				<table>
					<tr>
						<th style="width:10%"></th>
						<th style="width:15%">ID</th>
						<th style="width:30%">Название</th>
						<th style="width:5%">Вес</th>
						<th style="width:15%">%</th>
						<th style="width:15%">Сортировка</th>
						<th style="width:10%"></th>
					</tr>
					<tr v-for="ax in debug.axis">
						<td style="width:10%"></td>
						<td style="width:15%">{{ax.ID}}</td>
						<td style="width:30%">{{ax.NAME}}</td>
						<td style="width:5%">{{ax.WEIGHT}}</td>
						<td style="width:15%">{{ax.PERCENT}}</td>
						<td style="width:15%">{{ax.SORT}}</td>
						<td style="width:10%"></td>
					</tr>
				</table>
			</div>
			
			
            <div class="material" v-if="articles.length">
                <h4>Материалы, которые могут быть вам интересны:</h4>
                <div class="box">
                    <div class="item"
							v-for="article in articles"
							v-bind:key="'article'+article.ID"
						>
                        <img v-if="article.PREVIEW_PICTURE" v-bind:src="article.PREVIEW_PICTURE.SRC" alt="">
                        <p>{{article.NAME}}</p>
                        <a v-bind:href="article.DETAIL_PAGE_URL">Читать <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 39.3 26.2">
                            <path d="M25.5.7l12.4 12.4-12.4 12.4M37.9 13.1H0" fill="none" stroke="#ffffff" stroke-width="2" stroke-miterlimit="10"></path>
                        </svg></a>
                    </div>
                </div>
            </div>
			
			<div class="loader" v-if="timeout">
				<div class="bar">
					<div class="logo" v-if="loaderlogo">
						<img v-bind:src="loaderlogo" alt="">
					</div>
					<div class="bar-ins">
						<div class="bar-progress"></div>
					</div>
				</div>
			</div>
			
        </div>
	`
});